import { render, staticRenderFns } from "./RcvExD.vue?vue&type=template&id=408e5824"
import script from "./RcvExD.vue?vue&type=script&lang=js"
export * from "./RcvExD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports